import React, { useState, useEffect } from "react";
import {
  DatePicker,
  Select,
  Row,
  Col,
  Button,
  message,
  Space,
  Modal,
  Tag,
  Card,
  Avatar,
  Form,
  Descriptions,
  Divider,
  Typography,
  Input,
  Table,
  Popconfirm,
  Checkbox,
  Dropdown,
  Grid,
} from "antd";
import dayjs from "dayjs";
import {
  StarFilled,
  GiftOutlined,
  EnvironmentOutlined,
  ToolOutlined,
  BuildOutlined,
  ClockCircleTwoTone,
  DeleteOutlined,
  UserOutlined,
  EnvironmentFilled,
  DownOutlined,
} from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faWrench } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  GetWorkOrderByIdApi,
  GetWorkOrderItemsByWorkOrderIdApi,
} from "../ClientsApi";
import { useParams } from "react-router-dom";
import { getTechniciansAPI } from "CommonComponents/Lookup/LookupAPI";
import {
  addAppointmentForWOAPI,
  getAppointmentDetailsByApptId,
  getTechnicianAvailability,
  updateAppointmentForWOAPI,
} from "./AppointmentApi";
import { getProductsServicesAPI } from "features/ProductsandServices/ProductsandServicesAPI";
import StatusEnum from "features/Enums/StatusEnum";
import { resetAppointmentByApptId } from "./AppointmentSlice";
import { FormattedMessage, useIntl } from "react-intl";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import { GetSubContractorsApi } from "features/Admin/SubContractor/SubContractorAPI";

const { Option } = Select;
const { Column } = Table;

const generateTimeSlots = (
  date,
  isEndTime = false,
  startTimeValue = null,
  startDate = null,
  endDate = null
) => {
  const slots = [];
  const now = dayjs();
  const isToday = date ? dayjs(date).isSame(now, "day") : false;
  const isSameDay =
    startDate && endDate ? dayjs(startDate).isSame(endDate, "day") : false;

  for (let hour = 0; hour <= 23; hour++) {
    const time24 = `${hour.toString().padStart(2, "0")}:00`;
    const label = dayjs(time24, "HH:mm").format("HH:mm ");
    if (isEndTime && startTimeValue) {
      const slotTime = dayjs(time24, "HH:mm");
      const startTimeObj = dayjs(startTimeValue, "HH:mm");
      if (slotTime.isAfter(startTimeObj, "minute")) {
        slots.push({ value: time24, label });
      }
    } else if (isToday && !isEndTime) {
      const slotTime = dayjs(time24, "HH:mm");
      if (slotTime.isAfter(now, "minute")) {
        slots.push({ value: time24, label });
      }
    } else if (!isEndTime) {
      slots.push({ value: time24, label });
    }
  }

  if (isEndTime && startTimeValue) {
    const startHour = parseInt(startTimeValue.split(":")[0]);
    if (startHour >= 12) {
      slots.push({
        value: "00:00",
        label: "00:00 (Midnight)",
      });
    }
  }

  return slots.sort((a, b) => {
    if (a.value === "00:00") return 1;
    if (b.value === "00:00") return -1;
    return dayjs(a.value, "HH:mm").diff(dayjs(b.value, "HH:mm"));
  });
};

const DispatchTool = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const intl = useIntl();
  const today = dayjs();
  const { clientId, workOrderId } = useParams();
  //const [selectedDate, setSelectedDate] = useState(today);
  const [startTime, setStartTime] = useState(
    props?.initialValues?.time || null
  );
  const [endTime, setEndTime] = useState(null);
  //const [endDate, setEndDate] = useState(today);
  const [selectedTechnicians, setSelectedTechnicians] = useState([]);
  const [isDispatchModalVisible, setIsDispatchModalVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showTechnicians, setShowTechnicians] = useState(
    props?.isEditMode ? true : false
  );
  const [selectedDate, setSelectedDate] = useState(
    props?.initialValues?.selectedDate
      ? dayjs(props.initialValues.selectedDate)
      : today
  );
  const [endDate, setEndDate] = useState(
    props?.initialValues?.selectedDate
      ? dayjs(props.initialValues.selectedDate)
      : today
  );
  const [selectedSubContractor, setSelectedSubContractor] = useState([]);
  const [viewType, setViewType] = useState(() => {
    if (props?.isEditMode) {
      return "technicians";
    }
    if (props?.initialValues?.subContractorId) return "subcontractors";
    else if (props?.initialValues?.techId) return "technicians";
    return "technicians";
  });
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const workOrderDetails = useSelector(
    (state) => state.clients.workOrderDetails
  );
  const workOrderItems = useSelector(
    (state) => state.clients.workOrderItemList?.items || []
  );
  const techniciansList = useSelector((state) => state.lookup.technicians);
  const productsList = useSelector(
    (state) => state.productsServices.productsList
  );
  const technicianAvailable = useSelector(
    (state) => state.appointments.technicianAvailability || []
  );
  const appointmentByApptId = useSelector(
    (state) => state.appointments.appointmentByApptId
  );
  const partnerClientById = useSelector(
    (state) => state?.clients?.partnerClientById
  );
  const subContractorsList = useSelector(
    (state) => state.subContractor.subContractorRecords
  );
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const input = {
    pageNumber: null,
    pageSize: null,
    searchQuery: "",
    companyFilter: null,
    statusFilter: null,
    salespersonFilter: null,
    startDate: null,
    endDate: null,
    quoteTypeIds: null,
    statusIds: null,
  };
  const startTimeSlots = generateTimeSlots(selectedDate);
  const endTimeSlots = generateTimeSlots(
    endDate || selectedDate,
    true,
    startTime,
    selectedDate,
    endDate
  );
  const skills = Array.from(
    new Set(
      (techniciansList || [])
        .map((tech) => tech.skill?.split(",").map((s) => s.trim()))
        .flat()
        .filter(Boolean)
    )
  ).sort();

  const services = Array.from(
    new Set(
      subContractorsList
        ?.map((subContractor) =>
          subContractor.areaOfWork?.split(",")?.map((s) => s.trim())
        )
        .flat()
        .filter(Boolean)
    )
  ).sort();

  const onSkillChange = (checkedValues, skill) => {
    if (checkedValues.target.checked) {
      setSelectedSkills((prev) => [...prev, skill]);
    } else {
      setSelectedSkills((prev) => prev.filter((s) => s !== skill));
    }
  };

  const onServiceChange = (checkedValues, service) => {
    if (checkedValues.target.checked) {
      setSelectedServices((prev) => [...prev, service]);
    } else {
      setSelectedServices((prev) => prev.filter((s) => s !== service));
    }
  };

  const items = skills.map((skill) => ({
    key: skill,
    label: (
      <Checkbox
        checked={selectedSkills.includes(skill)}
        onChange={(e) => onSkillChange(e, skill)}
      >
        {skill}
      </Checkbox>
    ),
  }));

  const servicesFilterItems = services.map((service) => ({
    key: service,
    label: (
      <Checkbox
        checked={selectedServices.includes(service)}
        onChange={(e) => onServiceChange(e, service)}
      >
        {service}
      </Checkbox>
    ),
  }));
  const { Text, Title } = Typography;

  const isTechAvailable = (techId) => {
    if (!technicianAvailable || technicianAvailable.length === 0) return true;
    const found = technicianAvailable?.find((t) => t.technicianId === techId);
    return found ? found.isAvailable : true;
  };
  const handleTechnicianAssignment = (tech) => {
    setSelectedTechnicians((prev) => {
      const isAlreadySelected = prev.find((t) => t.id === tech.id);

      if (isAlreadySelected) {
        return prev.filter((t) => t.id !== tech.id);
      } else {
        setSelectedSubContractor([]);
        setViewType("technicians");

        const existingTech = prev.find((t) => t.id === tech.id);
        if (existingTech) {
          return prev.map((t) =>
            t.id === tech.id ? { ...tech, ...existingTech } : t
          );
        }
        return [...prev, tech];
      }
    });
  };
  const isTechnicianSelected = (techId) =>
    selectedTechnicians.some((tech) => tech.id === techId);

  const handleNextToTechnicians = () => {
    if (selectedItems.length === 0) {
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "AddAppointment.Error.PleaseSelectLineItems"
      );
      return;
    }
    setShowTechnicians(true);
  };
  const handleSubContractorAssignment = (subContractor) => {
    setSelectedSubContractor((prev) => {
      const isAlreadySelected = prev.find((sc) => sc.id === subContractor.id);

      if (isAlreadySelected) {
        return prev.filter((sc) => sc.id !== subContractor.id);
      } else {
        setSelectedTechnicians([]);
        setViewType("subcontractors");
        const existingSubContractor = prev.find(
          (sc) => sc.id === subContractor.id
        );
        if (existingSubContractor) {
          return prev.map((sc) =>
            sc.id === subContractor.id
              ? { ...subContractor, ...existingSubContractor }
              : sc
          );
        }
        return [...prev, subContractor];
      }
    });
  };

  const isSubContractorSelected = (subContractorId) =>
    selectedSubContractor.some((sc) => sc.id === subContractorId);
  const resetFormState = () => {
    form.resetFields();
    setSelectedDate(today);
    setEndDate(today);
    setStartTime(null);
    setEndTime(null);
    setSelectedTechnicians([]);
    setSelectedSubContractor([]);
    if (props?.initialValues?.subContractorId) {
      setViewType("subcontractors");
    } else if (props?.initialValues?.techId) {
      setViewType("technicians");
    } else {
      setViewType("technicians");
    }
    setSelectedServices([]);
    setSelectedItems([]);
    setSelectedRowKeys([]);
    //setShowTechnicians(false);
    setShowTechnicians(props?.isEditMode ? true : false);
    setIsDispatchModalVisible(false);
    // resetAppointmentByApptId();
    if (!props?.isEditMode) {
      dispatch(resetAppointmentByApptId());
    }
    form.setFieldsValue({
      startDate: today,
      endDate: today,
      startTime: props?.initialValues?.time,
    });
  };

  const handleConfirmDispatch = async () => {
    if (!selectedDate || !startTime || !endTime || selectedItems.length === 0) {
      message.error("Please select all required fields");
      return;
    }
    if (selectedTechnicians.length > 0 && selectedSubContractor.length > 0) {
      message.error(
        "Cannot assign both technicians and subcontractors. Please select only one."
      );
      return;
    }
    try {
      setLoading(true);
      const processedEndTime = endTime === "00:00" ? "23:59" : endTime;
      const existingAppointmentId = appointmentByApptId?.id || 0;
      const apptObj = {
        Id: existingAppointmentId,
        AppointmentNumber: "",
        WorkOrderId: props?.workOrderId || parseInt(workOrderId),
        StartDate: dayjs(selectedDate).format("YYYY-MM-DD"),
        StartTime: startTime
          ? dayjs(startTime, "HH:mm").format("HH:mm:ss")
          : null,
        EndDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
        EndTime: processedEndTime
          ? dayjs(processedEndTime, "HH:mm").format("HH:mm:ss")
          : null,
        AppointmentStatusId: StatusEnum.NotStarted.id,
        HourlyRate: selectedTechnicians[0]?.rate || null,
        TotalEstimatedCost: calculateTotalCost() || null,
        ClientId: clientId || props?.selectedClientId || null,
        PartnerId: partnerClientById?.id || props?.selectedPartnerId || null,
        IsActive: true,
        AppointmentItems: selectedItems.map((item) => ({
          Id: 0,
          AppointmentId: existingAppointmentId,
          ProductServiceId: item.productServiceId,
          Description: item.description,
          Quantity: item.quantity,
          UnitPrice: item.unitPrice,
          Amount: item.amount,
        })),
        AppointmentTechnicians:
          viewType === "subcontractors"
            ? []
            : selectedTechnicians.map((tech, index) => ({
                Id: 0,
                AppointmentId: existingAppointmentId,
                TechnicianId: tech.id,
                TechnicianName: `${tech.firstName} ${tech.lastName}`,
                TechnicianStatusId: StatusEnum.Waiting.id,
                IsPrimaryTechnician: index === 0,
              })),
        AppointmentSubContractors:
          viewType === "subcontractors"
            ? selectedSubContractor.map((subContractor, index) => ({
                Id: 0,
                AppointmentId: existingAppointmentId,
                SubContractorId: subContractor.id,
                SubContractorName: subContractor.name,
                SubContractorStatusId: StatusEnum.Waiting.id,
                IsPrimarySubContractor: index === 0,
              }))
            : [],
      };
      let response;
      if (appointmentByApptId?.id) {
        response = await dispatch(updateAppointmentForWOAPI(apptObj, input));
      } else {
        response = await dispatch(addAppointmentForWOAPI(apptObj, input));
      }
      if (response) {
        resetFormState();
        if (props?.onClose) props?.onClose();
        if (props?.initialValues?.onCancel) {
          props.initialValues.onCancel();
        }
      }
    } catch (error) {
      message.error("Failed to create appointment. Please try again.");
      console.error("Error creating appointment:", error);
    } finally {
      setLoading(false);
    }
  };

  const validateBeforeSubmit = () => {
    if (
      selectedTechnicians.length === 0 &&
      selectedSubContractor.length === 0
    ) {
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "AddAppointment.Error.SelectTechnician"
      );
      return false;
    }

    if (selectedTechnicians.length > 0 && selectedSubContractor.length > 0) {
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "AddAppointment.Error.PleaseSelectSubContractor"
      );
      return false;
    }
    return true;
  };
  const getFilteredSubContractors = () => {
    if (!subContractorsList || !Array.isArray(subContractorsList)) return [];

    return subContractorsList.filter((subContractor) => {
      const matchesSearch =
        subContractor.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        subContractor.companyName
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        subContractor.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        subContractor.areaOfWork
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());

      const matchesServices =
        selectedServices.length === 0 ||
        (subContractor.areaOfWork &&
          selectedServices.some((service) =>
            subContractor.areaOfWork
              .split(",")
              .map((s) => s.trim())
              .includes(service)
          ));

      return matchesSearch && matchesServices;
    });
  };
  const calculateTotalCost = () => {
    if (!startTime || selectedTechnicians.length === 0) return 0;

    const startHour = parseInt(startTime.split(":")[0], 10);
    const endHour = endTime
      ? parseInt(endTime.split(":")[0], 10)
      : startHour + 1;
    const hours = Math.max(1, endHour - startHour);

    return selectedTechnicians.reduce(
      (total, tech) => total + tech.rate * hours,
      0
    );
  };
  const workOrderItemsWithKey = workOrderItems.map((item) => ({
    ...item,
    key: item.productServiceId,
    productServiceName:
      productsList?.items?.find((p) => p.id === item.productServiceId)?.name ||
      "N/A",
  }));

  const getSortedTechnicians = () => {
    const filtered = techniciansList.filter((tech) => {
      const matchesSearch =
        tech.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        tech.lastName.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesSkills =
        selectedSkills.length === 0 ||
        (tech.skill &&
          selectedSkills.some((skill) =>
            tech.skill
              .split(",")
              .map((s) => s.trim())
              .includes(skill)
          ));

      return matchesSearch && matchesSkills;
    });

    // Sort: assigned technicians first, then others
    return filtered.sort((a, b) => {
      const aSelected = isTechnicianSelected(a.id) ? 1 : 0;
      const bSelected = isTechnicianSelected(b.id) ? 1 : 0;
      return bSelected - aSelected; // Assigned ones come first
    });
  };
  useEffect(() => {
    dispatch(getTechniciansAPI());
    dispatch(GetWorkOrderByIdApi(workOrderId || props?.workOrderId));
    if (appointmentByApptId?.id) {
      dispatch(getAppointmentDetailsByApptId(appointmentByApptId?.id));
    }
    const selectedWorkOrderId = workOrderId || props?.workOrderId;
    dispatch(GetWorkOrderItemsByWorkOrderIdApi(input, selectedWorkOrderId));
    dispatch(
      getProductsServicesAPI({ pageNo: null, pageSize: null, searchQuery: "" })
    );
    dispatch(
      GetSubContractorsApi({ pageNumber: null, pageSize: 10, searchQuery: "" })
    );
  }, [workOrderId, props?.workOrderId]);
  useEffect(() => {
    if (selectedDate && startTime) {
      const startDateStr = dayjs(selectedDate).format("YYYY-MM-DD");
      const endTimeStr =
        endTime || dayjs(startTime, "HH:mm").add(1, "hour").format("HH:mm");
      dispatch(getTechnicianAvailability(startDateStr, startTime, endTimeStr));
    }
  }, [selectedDate, startTime, endTime]);

  useEffect(() => {
    const timeToUse = props?.initialValues?.time || startTime;
    if (timeToUse && !endTime) {
      const nextHour = dayjs(timeToUse, "HH:mm").add(1, "hour").format("HH:mm");
      setEndTime(nextHour);
      form.setFieldsValue({
        endTime: nextHour,
      });
    }
  }, [props?.initialValues?.time, startTime, form]);
  useEffect(() => {
    if (props?.selectedDate && props?.initialValues?.time) {
      setShowTechnicians(true);
    }
  }, [props?.selectedDate, props?.initialValues?.time]);
  useEffect(() => {
    const appt = appointmentByApptId || props?.initialValues;

    if (
      !workOrderItems?.length ||
      !techniciansList?.length ||
      !subContractorsList?.length
    ) {
      return;
    }

    if (props?.initialValues?.time) {
      const startDate = props?.initialValues?.selectedDate
        ? dayjs(props.initialValues.selectedDate)
        : today;
      setSelectedDate(startDate);
      setStartTime(props.initialValues.time);

      const nextHour = dayjs(props.initialValues.time, "HH:mm")
        .add(1, "hour")
        .format("HH:mm");
      setEndTime(nextHour);

      form.setFieldsValue({
        startDate: startDate,
        startTime: props?.initialValues?.time,
        endTime: nextHour,
      });
      if (props.initialValues.techId && techniciansList.length > 0) {
        const assignedTech = techniciansList.find(
          (tech) => tech.id === props.initialValues.techId
        );
        if (assignedTech) {
          setSelectedTechnicians([assignedTech]);
          setViewType("technicians");
        }
      }
      if (
        props.initialValues.subContractorId &&
        subContractorsList.length > 0
      ) {
        const assignedSubContractor = subContractorsList.find(
          (sc) => sc.id === props.initialValues.subContractorId
        );
        if (assignedSubContractor) {
          setSelectedSubContractor([assignedSubContractor]);
          setViewType("subcontractors");
        }
      }
    } else if (props?.isEditMode && appt) {
      const startDate = appt?.startDate ? dayjs(appt.startDate) : null;
      const endDate = appt?.endDate ? dayjs(appt.endDate) : null;
      setSelectedDate(startDate);
      setEndDate(endDate);
      setStartTime(appt?.startTime || null);
      setEndTime(appt?.endTime || null);

      if (appt?.appointmentTechnicians?.length > 0) {
        const assignedTechs = appt.appointmentTechnicians.map((at) => {
          const technician = techniciansList.find(
            (t) => t.id === at.technicianId
          );
          return (
            technician || {
              id: at.technicianId,
              firstName: "N/A",
              lastName: "",
            }
          );
        });
        setSelectedTechnicians(assignedTechs);
        setViewType("technicians");
      }

      if (appt?.appointmentSubContractors?.length > 0) {
        const assignedSubContractors = appt.appointmentSubContractors.map(
          (asc) => {
            const subContractor = subContractorsList.find(
              (sc) => sc.id === asc.subContractorId
            );
            return (
              subContractor || {
                id: asc.subContractorId,
                name: asc.subContractorName || "N/A",
                companyName: "N/A",
              }
            );
          }
        );
        setSelectedSubContractor(assignedSubContractors);
        setViewType("subcontractors");
      }

      const appointmentItems = appt?.appointmentItems || [];
      setSelectedItems(appointmentItems);
      setSelectedRowKeys(appointmentItems.map((item) => item.productServiceId));

      form.setFieldsValue({
        startDate: startDate,
        startTime: appt?.startTime || null,
        endTime: appt?.endTime || null,
      });

      if (appointmentByApptId?.id) {
        setShowTechnicians(true);
      }
    } else {
      resetFormState();
    }
  }, [
    appointmentByApptId,
    props?.initialValues,
    techniciansList,
    workOrderItems,
    subContractorsList,
    form,
  ]);

  useEffect(() => {
    if (props?.isEditMode && appointmentByApptId) {
      const appt = appointmentByApptId;

      if (appt?.appointmentTechnicians?.length > 0) {
        const assignedTechs = appt.appointmentTechnicians.map((at) => {
          const technician = techniciansList.find(
            (t) => t.id === at.technicianId
          );
          return {
            ...technician,
            appointmentTechnicianId: at.id, // Store the association ID
            technicianStatusId: at.technicianStatusId,
          };
        });
        setSelectedTechnicians(assignedTechs);
        setViewType("technicians");
      }

      if (appt?.appointmentSubContractors?.length > 0) {
        const assignedSubContractors = appt.appointmentSubContractors.map(
          (asc) => {
            const subContractor = subContractorsList.find(
              (sc) => sc.id === asc.subContractorId
            );
            return {
              ...subContractor,
              appointmentSubContractorId: asc.id, // Store the association ID
              subContractorStatusId: asc.subContractorStatusId,
            };
          }
        );
        setSelectedSubContractor(assignedSubContractors);
        setViewType("subcontractors");
      }

      const appointmentItems = appt?.appointmentItems || [];
      setSelectedItems(appointmentItems);
      setSelectedRowKeys(appointmentItems.map((item) => item.productServiceId));
    }
  }, [
    appointmentByApptId,
    techniciansList,
    subContractorsList,
    props?.isEditMode,
  ]);

  useEffect(() => {
    if (
      props?.initialValues?.techId &&
      techniciansList.length > 0 &&
      selectedTechnicians.length === 0
    ) {
      const assignedTech = techniciansList.find(
        (tech) => tech.id === props.initialValues.techId
      );
      if (assignedTech) {
        setSelectedTechnicians([assignedTech]);
      }
    }
    if (
      props?.initialValues?.subContractorId &&
      subContractorsList?.length > 0
    ) {
      const assignedSubContractor = subContractorsList.find(
        (sc) => sc.id === props?.initialValues?.subContractorId
      );
      if (assignedSubContractor) {
        setSelectedSubContractor([assignedSubContractor]);
        setViewType("subcontractors");
      }
    }
  }, [
    techniciansList,
    subContractorsList,
    props?.initialValues?.techId,
    props?.initialValues?.subContractorId,
  ]);

  return (
    <div>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={10} lg={9}>
          <Card>
            <h1>{workOrderDetails?.woNumber}</h1>
            <Space direction="vertical" size={8} className="mt-5px">
              <h5>{<FormattedMessage id="AddAppointment.WorkOrderDtls" />}</h5>
              <p>
                <BuildOutlined />{" "}
                {partnerClientById?.id != null
                  ? `${partnerClientById?.companyName} | ${workOrderDetails?.clientName}`
                  : workOrderDetails?.clientName}
              </p>
              <p>
                <EnvironmentOutlined />
                {workOrderDetails?.companyAddress ? (
                  <span>
                    {workOrderDetails.companyAddress.address1}
                    {workOrderDetails.companyAddress.address2
                      ? `, ${workOrderDetails.companyAddress.address2}`
                      : ""}
                    {workOrderDetails.companyAddress.city
                      ? `, ${workOrderDetails.companyAddress.city}`
                      : ""}
                    {workOrderDetails.companyAddress.provinceName
                      ? `, ${workOrderDetails.companyAddress.provinceName}`
                      : ""}
                    {workOrderDetails.companyAddress.countryName
                      ? `, ${workOrderDetails.companyAddress.countryName}`
                      : ""}
                    {workOrderDetails.companyAddress.zip
                      ? `, ${workOrderDetails.companyAddress.zip}`
                      : ""}
                  </span>
                ) : null}
              </p>
            </Space>
          </Card>

          <Form layout="vertical" size="large" className="mt-10" form={form}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label={<FormattedMessage id="AddAppointment.StartDate" />}
                  name="startDate"
                  initialValue={
                    props?.initialValues?.selectedDate
                      ? dayjs(props.initialValues.selectedDate)
                      : dayjs()
                  }
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "AddAppointment.Error.PleaseSelectStartDate",
                      }),
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={(current) =>
                      current && current < dayjs().startOf("day")
                    }
                    value={selectedDate}
                    onChange={(date) => {
                      setSelectedDate(date);
                      setStartTime(props?.initialValues?.time || null);
                      setEndDate(date);
                      form.setFieldsValue({ startDate: date, endDate: date });
                    }}
                    placeholder={intl.formatMessage({
                      id: "AddLeadCall.Placeholder.SelectDate",
                    })}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={<FormattedMessage id="AddAppointment.EndDate" />}
                  name="endDate"
                  initialValue={selectedDate}
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "AddAppointment.Error.PleaseSelectEndDate",
                      }),
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={(current) =>
                      current &&
                      (current < dayjs().startOf("day") ||
                        (selectedDate && current < selectedDate.startOf("day")))
                    }
                    value={endDate}
                    onChange={(date) => {
                      setEndDate(date);
                    }}
                    placeholder={intl.formatMessage({
                      id: "AddLeadCall.Placeholder.SelectDate",
                    })}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label={<FormattedMessage id="AddAppointment.StartTime" />}
                  name="startTime"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "AddAppointment.Error.PleaseSelectStartTime",
                      }),
                    },
                  ]}
                >
                  <Select
                    placeholder={
                      <FormattedMessage id="AddAppointment.Placeholder.StartTime" />
                    }
                    style={{ width: "100%" }}
                    value={props?.initialValues?.time || startTime}
                    allowClear
                    onChange={(value) => {
                      const selectedTime = value;
                      setStartTime(selectedTime);
                      if (selectedTime) {
                        const nextHour = dayjs(selectedTime, "HH:mm")
                          .add(1, "hour")
                          .format("HH:mm");
                        setEndTime(nextHour);
                        form.setFieldsValue({
                          endTime: nextHour,
                        });
                      } else {
                        setEndTime(null);
                        form.setFieldsValue({
                          endTime: null,
                        });
                      }
                    }}
                  >
                    {startTimeSlots.map((slot) => (
                      <Option key={slot.value} value={slot.value}>
                        {slot.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={<FormattedMessage id="AddAppointment.EndTime" />}
                  name="endTime"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "AddAppointment.Error.PleaseSelectEndTime",
                      }),
                    },
                  ]}
                >
                  <Select
                    placeholder={
                      <FormattedMessage id="AddAppointment.Placeholder.EndTime" />
                    }
                    style={{ width: "100%" }}
                    value={endTime}
                    onChange={(value) => setEndTime(value)}
                    allowClear
                  >
                    {endTimeSlots.map((slot) => (
                      <Option key={slot.value} value={slot.value}>
                        {slot.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>

        <Col xs={24} sm={24} md={14} lg={15}>
          {!startTime || !selectedDate || !startTime ? (
            // Show message when date/start time not selected
            <div
              style={{
                textAlign: "center",
                padding: "40px",
                color: "#999",
                borderRadius: 8,
              }}
            >
              <p style={{ fontSize: 16 }}>
                👉 {<FormattedMessage id="AddAppointment.EmptyContext" />}
              </p>
            </div>
          ) : (
            <>
              {/* Technician Header */}
              <div>
                {!showTechnicians ? (
                  // Step 1: Table with Next/Cancel
                  <div>
                    <Table
                      dataSource={workOrderItemsWithKey}
                      scroll={{ x: 500 }}
                      // rowSelection={{
                      //   type: "checkbox",
                      //   ...rowSelection,
                      //   selectedRowKeys,
                      // }}
                      rowSelection={{
                        type: "checkbox",
                        selectedRowKeys, // Pass the selected keys
                        onChange: (selectedRowKeys, selectedRows) => {
                          setSelectedRowKeys(selectedRowKeys);
                          setSelectedItems(selectedRows);
                        },
                        getCheckboxProps: (record) => ({
                          key: record.productServiceId,
                        }),
                        preserveSelectedRowKeys: true,
                      }}
                      pagination={false}
                      bordered
                      style={{ background: "#fff", borderRadius: 8 }}
                    >
                      {/* Line Item Column */}
                      <Column
                        title={
                          <FormattedMessage id="AddAppointment.LineItem" />
                        }
                        dataIndex="productServiceName"
                        key="productServiceName"
                        render={(text, record) => (
                          <span>
                            {
                              productsList?.items?.find(
                                (p) => p.id === record.productServiceId
                              ).name
                            }{" "}
                          </span>
                        )}
                      />
                      <Column
                        title={
                          <FormattedMessage id="AddAppointment.Quantity" />
                        }
                        dataIndex="quantity"
                        key="quantity"
                        render={(value) => value}
                      />
                      {/* Amount */}
                      <Column
                        title={<FormattedMessage id="AddAppointment.Amount" />}
                        dataIndex="amount"
                        key="amount"
                      />
                    </Table>
                  </div>
                ) : (
                  // Step 2: Technicians List
                  <div>
                    <div>
                      {viewType === "technicians" ? (
                        <>
                          {/* Header with Toggle Button */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: isMobile ? "column" : "row",
                              justifyContent: "space-between",
                              alignItems: isMobile ? "stretch" : "center",
                              gap: isMobile ? 8 : 12,
                              marginBottom: 12,
                            }}
                          >
                            <Button
                              type="default"
                              onClick={() => {
                                setViewType("subcontractors");
                                setSelectedSkills([]);
                              }}
                            >
                              {
                                <FormattedMessage id="AddAppointment.SubContractors" />
                              }
                            </Button>
                            <Dropdown
                              menu={{
                                items: [
                                  ...items,
                                  {
                                    key: "clear-all",
                                    label: (
                                      <Button
                                        type="link"
                                        onClick={() => setSelectedSkills([])}
                                        style={{
                                          width: "100%",
                                          textAlign: "left",
                                        }}
                                      >
                                        {
                                          <FormattedMessage id="AddAppointment.ClearAll" />
                                        }
                                      </Button>
                                    ),
                                  },
                                ],
                                selectable: true,
                                multiple: true,
                              }}
                              trigger={["click"]}
                              overlayStyle={{
                                maxHeight: 300,
                                overflow: "auto",
                              }}
                            >
                              <Button>
                                {
                                  <FormattedMessage id="AddAppointment.FilterSkills" />
                                }{" "}
                                ({selectedSkills.length})
                                <DownOutlined />
                              </Button>
                            </Dropdown>
                            <Input.Search
                              placeholder={intl.formatMessage({
                                id: "AddAppointment.Placeholder.SearchTechnician",
                              })}
                              allowClear
                              style={{ width: 250 }}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          </div>

                          <div style={{ height: "409px", overflow: "auto" }}>
                            {getSortedTechnicians().map((tech, index) => (
                              <Card
                                className="clientview-new"
                                key={tech.id}
                                style={{
                                  marginBottom: 12,
                                  borderRadius: 8,
                                  backgroundColor: isTechnicianSelected(tech.id)
                                    ? "#e6f7ff"
                                    : "#fff",
                                  border: isTechnicianSelected(tech.id)
                                    ? "1px solid #1890ff"
                                    : "1px solid #d9d9d9",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 12,
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontWeight: 600,
                                        fontSize: 14,
                                      }}
                                    >
                                      {index + 1}.
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: 6,
                                      }}
                                    >
                                      {/* <div
                                        style={{
                                          color: "#faad14",
                                          fontWeight: 600,
                                          fontSize: 10,
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 4,
                                        }}
                                      >
                                        {tech.rating} <StarFilled />
                                      </div> */}
                                      <Avatar
                                        size={36}
                                        style={{
                                          backgroundColor: "#999",
                                          color: "#fff",
                                          fontWeight: 600,
                                          fontSize: 12,
                                        }}
                                      >
                                        {tech?.firstName
                                          .split(" ")
                                          .map((n) => n[0])
                                          .join("")
                                          .toUpperCase()}
                                      </Avatar>
                                    </div>
                                    <div>
                                      <div style={{ fontWeight: 600 }}>
                                        {tech.firstName} {tech.lastName}
                                        {isTechnicianSelected(tech.id) && (
                                          <Tag
                                            color="blue"
                                            style={{ marginLeft: 8 }}
                                          >
                                            <FormattedMessage id="AddAppointment.SelectedTag" />
                                          </Tag>
                                        )}
                                      </div>
                                      <div
                                        style={{
                                          color: "#666",
                                          fontSize: 12,
                                        }}
                                      >
                                        <EnvironmentOutlined /> {tech.location}
                                      </div>
                                      <div
                                        style={{
                                          fontSize: 12,
                                          color: "#444",
                                        }}
                                      >
                                        {
                                          <FormattedMessage id="AddAppointment.Skills" />
                                        }
                                        : {tech.skill ? tech.skill : "N/A"}
                                      </div>
                                    </div>
                                  </div>
                                  <div style={{ textAlign: "right" }}>
                                    <Button
                                      type={
                                        isTechnicianSelected(tech.id)
                                          ? "primary"
                                          : "default"
                                      }
                                      size="small"
                                      style={{ marginTop: 6 }}
                                      onClick={() => {
                                        handleTechnicianAssignment(tech);
                                        setSelectedSubContractor([]);
                                      }}
                                      disabled={
                                        !isTechAvailable(tech.id) &&
                                        !isTechnicianSelected(tech.id)
                                      }
                                    >
                                      {isTechnicianSelected(tech.id) ? (
                                        <FormattedMessage id="AddAppointment.Assigned" />
                                      ) : isTechAvailable(tech.id) ? (
                                        <FormattedMessage id="AddAppointment.Assign" />
                                      ) : (
                                        <FormattedMessage id="AddAppointment.Unavailable" />
                                      )}
                                    </Button>
                                  </div>
                                </div>
                              </Card>
                            ))}

                            {getSortedTechnicians().length === 0 && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "100%",
                                  color: "#999",
                                  fontSize: 16,
                                }}
                              >
                                {
                                  <FormattedMessage id="AddAppointment.NoTechniciansFound" />
                                }
                              </div>
                            )}
                          </div>
                        </>
                      ) : (
                        <>
                          {/* Sub Contractors View */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: isMobile ? "column" : "row",
                              justifyContent: "space-between",
                              alignItems: isMobile ? "stretch" : "center",
                              gap: isMobile ? 8 : 12,
                              marginBottom: 12,
                            }}
                          >
                            <Button
                              type="default"
                              onClick={() => {
                                setViewType("technicians");
                                setSelectedServices([]);
                              }}
                            >
                              {
                                <FormattedMessage id="AddAppointment.Technician" />
                              }
                            </Button>

                            <Dropdown
                              menu={{
                                items: [
                                  ...servicesFilterItems,
                                  {
                                    key: "clear-all",
                                    label: (
                                      <Button
                                        type="link"
                                        onClick={() => setSelectedServices([])}
                                        style={{
                                          width: "100%",
                                          textAlign: "left",
                                        }}
                                      >
                                        {
                                          <FormattedMessage id="AddAppointment.ClearAll" />
                                        }
                                      </Button>
                                    ),
                                  },
                                ],
                                selectable: true,
                                multiple: true,
                              }}
                              trigger={["click"]}
                              overlayStyle={{
                                maxHeight: 300,
                                overflow: "auto",
                              }}
                            >
                              <Button>
                                {
                                  <FormattedMessage id="AddAppointment.FilterServices" />
                                }
                                {selectedServices.length > 0 &&
                                  ` (${selectedServices.length})`}
                                <DownOutlined />
                              </Button>
                            </Dropdown>

                            <Input.Search
                              placeholder={intl.formatMessage({
                                id: "AddAppointment.Placeholder.SearchSubContractor",
                              })}
                              allowClear
                              style={{ width: 250 }}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          </div>

                          <div style={{ height: "409px", overflow: "auto" }}>
                            {getFilteredSubContractors()
                              .filter((sub) => sub.isActive) // ✅ only active
                              .map((subContractor, index) => (
                                <Card
                                  className="clientview-new"
                                  key={subContractor.id}
                                  style={{
                                    marginBottom: 12,
                                    borderRadius: 8,
                                    backgroundColor: isSubContractorSelected(
                                      subContractor.id
                                    )
                                      ? "#e6f7ff"
                                      : "#fff",
                                    border: isSubContractorSelected(
                                      subContractor.id
                                    )
                                      ? "1px solid #1890ff"
                                      : "1px solid #d9d9d9",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 12,
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontWeight: 600,
                                          fontSize: 14,
                                        }}
                                      >
                                        {index + 1}.
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "center",
                                          gap: 6,
                                        }}
                                      >
                                        <Avatar
                                          size={36}
                                          style={{
                                            backgroundColor: "#999",
                                            color: "#fff",
                                            fontWeight: 600,
                                            fontSize: 12,
                                          }}
                                        >
                                          {subContractor?.companyName
                                            ?.charAt(0)
                                            ?.toUpperCase() || "S"}
                                        </Avatar>
                                      </div>
                                      <div>
                                        <div style={{ fontWeight: 600 }}>
                                          {subContractor.companyName}
                                          {isSubContractorSelected(
                                            subContractor.id
                                          ) && (
                                            <Tag
                                              color="blue"
                                              style={{ marginLeft: 8 }}
                                            >
                                              <FormattedMessage id="AddAppointment.SelectedTag" />
                                            </Tag>
                                          )}
                                        </div>
                                        <div
                                          style={{
                                            color: "#666",
                                            fontSize: 12,
                                          }}
                                        >
                                          <UserOutlined /> {subContractor.name}
                                        </div>
                                        <div
                                          style={{
                                            color: "#666",
                                            fontSize: 12,
                                          }}
                                        >
                                          <EnvironmentOutlined />{" "}
                                          {subContractor.mobile}
                                        </div>
                                        <div
                                          style={{
                                            fontSize: 12,
                                            color: "#444",
                                          }}
                                        >
                                          <FormattedMessage id="AddAppointment.Services" />
                                          : {subContractor.areaOfWork || "N/A"}
                                        </div>
                                      </div>
                                    </div>
                                    <div style={{ textAlign: "right" }}>
                                      <div
                                        style={{
                                          color: "#1890ff",
                                          fontWeight: 600,
                                        }}
                                      >
                                        ${subContractor.hourlyRate || 0}/hr
                                      </div>
                                      <Button
                                        type={
                                          isSubContractorSelected(
                                            subContractor.id
                                          )
                                            ? "primary"
                                            : "default"
                                        }
                                        size="small"
                                        style={{ marginTop: 6 }}
                                        onClick={() => {
                                          handleSubContractorAssignment(
                                            subContractor
                                          );
                                          setSelectedTechnicians([]);
                                        }}
                                        disabled={false}
                                      >
                                        {isSubContractorSelected(
                                          subContractor.id
                                        ) ? (
                                          <FormattedMessage id="AddAppointment.Assigned" />
                                        ) : (
                                          <FormattedMessage id="AddAppointment.Assign" />
                                        )}
                                      </Button>
                                    </div>
                                  </div>
                                </Card>
                              ))}

                            {getFilteredSubContractors().filter(
                              (sub) => sub.isActive
                            ).length === 0 && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "100%",
                                  color: "#999",
                                  fontSize: 16,
                                }}
                              >
                                <FormattedMessage id="AddAppointment.NoSubContractorFound" />
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </Col>
      </Row>
      {/* Action Buttons */}
      <div className="dispatchactionbuttons">
        {showTechnicians && (
          <Button
            style={{ marginRight: 8 }}
            onClick={() => setShowTechnicians(false)}
          >
            {<FormattedMessage id="AddAppointment.Back" />}
          </Button>
        )}
        <Button
          danger
          onClick={() => {
            resetFormState();
            if (props?.onClose) {
              props.onClose();
            }
            if (props?.initialValues?.onCancel) {
              props.initialValues.onCancel();
            }
          }}
        >
          {<FormattedMessage id="Common.Cancel" />}
        </Button>
        &nbsp;
        {!showTechnicians && (
          <Button type="primary" onClick={handleNextToTechnicians}>
            {<FormattedMessage id="AddAppointment.Next" />}
          </Button>
        )}
        &nbsp;
        {showTechnicians && (
          <Button
            type="primary"
            onClick={() => {
              if (validateBeforeSubmit()) {
                setIsDispatchModalVisible(true);
              }
            }}
          >
            {<FormattedMessage id="Common.Submit" />}
          </Button>
        )}
      </div>

      <Modal
        title={<FormattedMessage id="AddAppointment.ConfirmDispatch" />}
        open={isDispatchModalVisible}
        width={600}
        onOk={handleConfirmDispatch}
        onCancel={() => {
          setIsDispatchModalVisible(false);
        }}
        centered
        cancelText={<FormattedMessage id="Common.Cancel" />}
        okText={<FormattedMessage id="Common.Confirm" />}
        confirmLoading={loading}
      >
        {viewType === "technicians" && selectedTechnicians.length > 0 && (
          <>
            <div style={{ marginBottom: 16 }}>
              <Text strong>
                <FormattedMessage id="AddAppointment.SelectedTechnicians" /> (
                {selectedTechnicians.length}):
              </Text>
            </div>

            {selectedTechnicians.map((technician, index) => (
              <div key={technician.id}>
                <Descriptions
                  column={1}
                  bordered
                  size="small"
                  labelStyle={{ fontWeight: 600, width: 180 }}
                  contentStyle={{ fontSize: 14 }}
                  title={`Technician ${index + 1}`}
                >
                  <Descriptions.Item
                    label={<FormattedMessage id="AddAppointment.Technician" />}
                  >
                    {technician.firstName} {technician.lastName}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={<FormattedMessage id="AddAppointment.Email" />}
                  >
                    {technician.email}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={<FormattedMessage id="AddAppointment.PhoneNumber" />}
                  >
                    {technician.countryCode || "+1"}&nbsp;
                    {technician.phone}
                  </Descriptions.Item>
                </Descriptions>

                {index < selectedTechnicians.length - 1 && (
                  <Divider style={{ margin: "16px 0" }} />
                )}
              </div>
            ))}
          </>
        )}

        {viewType === "subcontractors" && selectedSubContractor.length > 0 && (
          <>
            <div style={{ marginBottom: 16 }}>
              <Text strong>
                <FormattedMessage id="AddAppointment.SelectedSubContractor" /> (
                {selectedSubContractor.length}):
              </Text>
            </div>

            {selectedSubContractor.map((subContractor, index) => (
              <div key={subContractor.id}>
                <Descriptions
                  column={1}
                  bordered
                  size="small"
                  labelStyle={{ fontWeight: 600, width: 180 }}
                  contentStyle={{ fontSize: 14 }}
                  title={`Sub-Contractor ${index + 1}`}
                >
                  <Descriptions.Item
                    label={<FormattedMessage id="SubContractor.CompanyName" />}
                  >
                    {subContractor.companyName}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <FormattedMessage id="ClientDetails.ContactPerson" />
                    }
                  >
                    {subContractor.name}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={<FormattedMessage id="Common.Email" />}
                  >
                    {subContractor.email}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={<FormattedMessage id="Common.PhoneNumber" />}
                  >
                    {subContractor.countryCode} {subContractor.mobile}
                  </Descriptions.Item>
                </Descriptions>

                {index < selectedSubContractor.length - 1 && (
                  <Divider style={{ margin: "16px 0" }} />
                )}
              </div>
            ))}

            <Divider style={{ margin: "16px 0" }} />
          </>
        )}

        {/* Divider */}
        <Divider style={{ margin: "16px 0" }} />

        {/* Time Info */}
        {startTime && (
          <Text style={{ fontSize: 15 }}>
            <ClockCircleTwoTone />{" "}
            <FormattedMessage id="AddAppointment.ScheduledTime" />
            :&nbsp;&nbsp;
            <strong>
              {startTime} -
              {endTime ||
                dayjs(startTime, "HH:mm").add(1, "hour").format("HH:mm")}
            </strong>
          </Text>
        )}
      </Modal>
    </div>
  );
};

export default DispatchTool;
